import React, { useEffect, useRef, useCallback } from 'react';
import * as wordanimation from '../../util/alaska.ui.wordanimation';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks';

const BigLoader = () => {
  const { t } = useTranslation();
  const loader = useAppSelector((state) => state.loader);
  const ref = useRef<HTMLDivElement>(null);
  const hideTimeoutRef = useRef<NodeJS.Timeout>(null);

  const showBigLoader = useCallback(
    (title?: string, subtitle?: string) => {
      if (ref.current) {
        const initializingComponent = ref.current;
        const initCanvas =
          initializingComponent.getElementsByTagName('canvas')[0];
        initializingComponent.style.transition = `opacity 20ms, transform 20ms`;
        initializingComponent.style.opacity = '1';
        initializingComponent.style.display = 'block';
        wordanimation.init(
          initCanvas,
          title || 'ALASKA',
          subtitle || t('loading...')
        );
      }
    },
    [ref, t]
  );

  const hideBigLoader = useCallback(() => {
    if (ref.current) {
      const initializingComponent = ref.current;
      const initCanvas =
        initializingComponent.getElementsByTagName('canvas')[0];
      initializingComponent.style.transition = `opacity 250ms, transform 250ms`;
      initializingComponent.style.opacity = '0';
      initializingComponent.style.display = 'block';

      hideTimeoutRef.current = setTimeout(() => {
        wordanimation.stop(initCanvas);
        initializingComponent.style.display = 'none';
      }, 500);
    }
  }, [ref, hideTimeoutRef]);

  // watch for the show hide property changes - triggered from the dispatcher below
  useEffect(() => {
    if (loader) {
      showBigLoader(loader.title, loader.subTitle);
    } else {
      hideBigLoader();
    }
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, [loader, showBigLoader, hideBigLoader, hideTimeoutRef]);

  return (
    <div id="initializing" style={{ display: 'none' }} ref={ref}>
      <canvas />
    </div>
  );
};

export default BigLoader;
